module.exports = {
      id: "liveupdate-usage",
      viewBox: "0 0 14.54 20",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#liveupdate",
      toString: function () {
        return this.url;
      }
    }